import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2Icon } from 'lucide-react';
export function Includes() {
  const items = ['Un solo PDF descargable con los 7 capítulos completos', 'Recetas y protocolo integrados (no son archivos sueltos)', 'Listo para leer en el móvil, tablet o imprimir en casa', 'Acceso inmediato + de por vida tras el pago'];
  return <section className="py-12 md:py-24 bg-forest text-cream" data-id="element-283">
      <FadeIn className="container mx-auto px-5 max-w-[1100px]" data-id="element-284">
        <div className="flex flex-col md:flex-row items-center gap-10 lg:gap-16" data-id="element-285">
          {/* Left Column: Text */}
          <div className="w-full md:w-1/2" data-id="element-286">
            <div className="text-peach text-sm font-semibold tracking-[0.2em] uppercase mb-3 md:mb-4" data-id="element-287">
              Qué incluye tu ebook
            </div>
            <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-cream mb-4 md:mb-6 leading-tight" data-id="element-288">
              Todo en un solo lugar.
              <br data-id="element-289" />
              <span className="italic text-peach" data-id="element-290">Un solo ebook.</span>
            </h2>
            <p className="text-sand text-lg mb-8 leading-relaxed" data-id="element-291">
              <span className="text-peach font-medium" data-id="element-292">Libre de Endodolor</span>{' '}
              es <span className="text-cream font-bold" data-id="element-293">un único PDF</span> con
              los 7 capítulos del método, las recetas Endo-Friendly, el
              protocolo de 21 días, las infusiones, la bitácora y la lista de
              compras — todo integrado, todo dentro del mismo documento.
            </p>
            <ul className="space-y-5" data-id="element-294">
              {items.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-295">
                  <div className="mt-1 text-peach shrink-0" data-id="element-296">
                    <CheckCircle2Icon className="w-5 h-5" data-id="element-297" />
                  </div>
                  <span className="text-lg text-sand/90" data-id="element-298">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Right Column: Image & Price Tag */}
          <div className="w-full md:w-1/2 relative" data-id="element-299">
            <div className="rounded-2xl overflow-hidden shadow-2xl" data-id="element-300">
              <img src="https://cdn.magicpatterns.com/uploads/r571Vr3NiH48vVauDJmbox/Mockut_del_e_book.png" alt="Mockup del ebook Libre de Endodolor" className="w-full h-auto object-cover" data-id="element-301" />
            </div>

            {/* Price Tag Overlay */}
            <div className="absolute bottom-3 right-3 md:bottom-4 md:-right-8 bg-burgundy border border-peach/20 rounded-xl p-4 md:p-6 shadow-2xl z-10 min-w-[160px] md:min-w-[200px]" data-id="element-302">
              <div className="text-peach text-[10px] md:text-xs font-semibold tracking-widest uppercase mb-1.5 md:mb-2" data-id="element-303">
                Precio Hoy
              </div>
              <div className="flex items-baseline gap-2 md:gap-3 mb-1" data-id="element-304">
                <span className="text-sand/60 line-through text-base md:text-lg" data-id="element-305">
                  $17.00
                </span>
                <span className="font-serif text-3xl md:text-4xl text-cream" data-id="element-306">
                  $6.36
                </span>
              </div>
              <div className="text-peach text-xs md:text-sm font-medium" data-id="element-307">
                63% OFF
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}